<template>
  <div class="gh-card__actions">
    <GenerationHistoryActionTooltip :text="$t('generation_history.actions.copy_text')">
      <button
        type="button"
        class="gh-card__action"
        :class="{ 'is-copied': isCopied }"
        :aria-label="$t('generation_history.actions.copy_text')"
        @click="$emit('copy')"
      >
        <GenerationHistorySvgIcon :src="iconCopy" />
      </button>
    </GenerationHistoryActionTooltip>
    <GenerationHistoryActionTooltip :text="$t('generation_history.actions.download')">
      <button
        type="button"
        class="gh-card__action"
        :aria-label="$t('generation_history.actions.download')"
        @click="$emit('download')"
      >
        <img :src="iconDownload" alt="" class="gh-card__action-icon">
      </button>
    </GenerationHistoryActionTooltip>
    <GenerationHistoryActionTooltip :text="$t('generation_history.actions.favorite')">
      <button
        type="button"
        class="gh-card__action"
        :class="{ 'is-favorite': isFavorite }"
        :aria-label="$t('generation_history.actions.favorite')"
        @click="$emit('favorite')"
      >
        <img
          :src="isFavorite ? iconStarFilled : iconStar"
          alt=""
          class="gh-card__action-icon"
        >
      </button>
    </GenerationHistoryActionTooltip>
  </div>
</template>

<script>
import iconCopy from '@/assets/img/common/icon-copy.svg';
import iconDownload from '@/assets/img/common/gh-icon-download.svg';
import iconStar from '@/assets/img/common/icon-star.svg';
import iconStarFilled from '@/assets/img/common/icon-star-filled.svg';
import GenerationHistoryActionTooltip from './GenerationHistoryActionTooltip.vue';
import GenerationHistorySvgIcon from './GenerationHistorySvgIcon.vue';

export default {
  name: 'GenerationHistoryCardActions',
  components: {
    GenerationHistoryActionTooltip,
    GenerationHistorySvgIcon,
  },
  props: {
    isFavorite: {
      type: Boolean,
      default: false,
    },
    isCopied: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      iconCopy,
      iconDownload,
      iconStar,
      iconStarFilled,
    };
  },
};
</script>
